/**
 * CONFETE — a comemoração do 1.0 (`lancarConfetti`), sem biblioteca: ~60 pedacinhos que caem e
 * somem em 3,5 s. Dispara ao escolher o card da premiação e ao registrar a venda (dono, 25/09).
 * Quem pediu "reduzir movimento" no aparelho não vê animação. Nunca atrapalha o clique: a camada
 * não recebe toque e se apaga sozinha.
 */

const CORES = ['#cb1b2b', '#1a7f55', '#d9a23c', '#1a5c9e', '#e38b92', '#6fb89a', '#f2c94c'];
const DURACAO = 3500;

export function soltarConfete(quantidade = 60): void {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const camada = document.createElement('div');
    camada.className = 'confete';
    camada.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < quantidade; i++) {
      const p = document.createElement('i');
      const tamanho = 6 + Math.random() * 6;
      p.style.left = `${String(Math.random() * 100)}vw`;
      p.style.width = `${String(tamanho)}px`;
      p.style.height = `${String(tamanho * 0.45)}px`;
      p.style.background = CORES[i % CORES.length] ?? '#d9a23c';
      p.style.animationDelay = `${String(Math.random() * 0.6)}s`;
      p.style.animationDuration = `${String(2.2 + Math.random() * 1.2)}s`;
      p.style.setProperty('--giro', `${String(Math.round(360 + Math.random() * 720))}deg`);
      p.style.setProperty('--desvio', `${String(Math.round(Math.random() * 120 - 60))}px`);
      camada.appendChild(p);
    }
    document.body.appendChild(camada);
    window.setTimeout(() => camada.remove(), DURACAO + 800);
  } catch {
    // comemoração nunca derruba a venda
  }
}
